//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'detailsForm',
  props: {
    formData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      drawer: false,
      id: 0,
      type: '',
      edit: false
    };
  },
  methods: {}
};